export const GET_JOBS_Request ="GET_JOBS_Request";
export const GET_JOBS_Success ="GET_JOBS_Success";
export const GET_JOBS_Error ="GET_JOBS_Error";


// get data for singal post for job
export const SINGAL_JOB_REQUEST ="SINGAL_JOB_REQUEST";
export const SINGAL_JOB_SUCCESS ="SINGAL_JOB_SUCCESS";
export const SINGAL_JOB_ERROR ="SINGAL_JOB_ERROR";

//apply for job
export const APPLY_JOB_REQUEST ="APPLY_JOB_REQUEST";
export const APPLY_JOB_SUCCESS ="APPLY_JOB_SUCCESS";
export const APPLY_JOB_ERROR ="APPLY_JOB_ERROR"